<template>
  <div>
    <div v-if="$route.path.indexOf('_detail') === -1">
      <el-table :data="sucaiData"  v-loading="loading"  @selection-change="handleSelectionChange">
        <el-table-column type="selection" align="center" label="全选"></el-table-column>
        <el-table-column prop="id" label="ID" width="130"></el-table-column>
        <el-table-column label="初始模板" width="100">
          <template slot-scope="scope">
            <el-popover placement="right" width="240" trigger="hover">
              <img :src="scope.row.primeval_url" style="width:100%;">
              <el-button type="text" slot="reference"><img style="width:50px;height:50px;" :src="scope.row.primeval_url"></el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="当前模板" width="100">
          <template slot-scope="scope">
            <el-popover placement="right" width="240" trigger="hover">
            <img :src="scope.row.current_url" style="width:100%;">
            <el-button type="text" slot="reference"><img style="width:50px;height:50px;" :src="scope.row.current_url"></el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="名称" width="130"></el-table-column>
        <el-table-column label="操作" width="130">
          <template slot-scope="scope">
            <el-button type="text" @click="editInfo(scope.row)" class="btn-gap">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
     <div v-if="total_count > params.pageSize" class="content-padded tc">
      <el-pagination background   layout="prev, pager, next, total" @current-change="handleCurrentChange" :current-page.sync="params.page" :total='total_count' :page-size='params.pageSize'>
      </el-pagination>
    </div>

      <el-dialog  :title="dialogTitle" class="right-dialog" :visible.sync="editInfoDialog" :before-close="handleCancelLabelsDialog">
      <template>
        <el-form>
          <el-form-item label-width="100px" label="标题">
            <el-input v-model="updateForm.title" placeholder="标题"></el-input>
          </el-form-item>

          <el-form-item label-width="100px" label="初始模板" prop="current_url">
            <div class="upload-box">
              <img :src="updateForm.primeval_url" class="avatar"/>
            </div>
          </el-form-item>

          <el-form-item label-width="100px" label="当前模板" prop="current_url">
            <div @click="handleImgPicker('current_url')" class="upload-box">
              <img v-if="updateForm.current_url" :src="updateForm.current_url" class="avatar"/>
              <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
            </div>
            <div class="frm-tips">
              温馨提示：修改模板时一定要仔细检查，替换的模板样式必须与固定模板样式保持一致；<br>
              如替换素材模板与固定样式不一致，分享素材会出现排版错乱，每次替换操作都将记录日志，请细心操作哦~
            </div>
          </el-form-item>

          <el-form-item class="content-center">
            <el-button type="primary" @click="editInfoSubmit()">确定</el-button>
          </el-form-item>
        </el-form>
      </template>
    </el-dialog>

    <imgPicker
      :dialog-visible="imgDialog"
      :sc-status="isGetImage"
      @chooseImg="pickImg"
      @closeImgDialog="closeImgDialog"
    ></imgPicker>

    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import {sucaiList, updateSucai} from '../../../api/sharer'
import imgPicker from '@/components/imageselect'
export default {
  components: { imgPicker },
  data () {
    return {
      total_count: 0,
      dialogTitle: '',
      loading: false,
      sucaiData: [],
      params: {
        page: 1,
        pageSize: 20
      },
      updateForm: {
        id: '',
        title: '',
        current_url: ''
      },
      editInfoDialog: false,
      pickerImgType: '',
      imgDialog: false,
      isGetImage: false
    }
  },
  methods: {
    getSucai (filter) {
      this.loading = true
      sucaiList(filter).then(response => {
        this.sucaiData = response.data.data.list
        this.total_count = Number(response.data.data.total_count)
        this.loading = false
      })
    },
    editInfo (row = '') {
      this.editInfoDialog = true
      if (row) {
        this.updateForm.id = row.id
        this.updateForm.title = row.title
        this.updateForm.primeval_url = row.primeval_url
        this.updateForm.current_url = row.current_url
        this.dialogTitle = '编辑素材模板'
      } else {
        this.dialogTitle = '添加素材模板'
        this.updateForm = {id: '', title: '', current_url: ''}
      }
    },
    editInfoSubmit () {
      // console.log(this.updateForm);
      updateSucai({id: this.updateForm.id, title: this.updateForm.title, current_url: this.updateForm.current_url}).then(res => {
        this.$message({ type: 'success', message: '更新成功'})
        this.editInfoDialog = false
        this.getSucai(this.params)
      })
    },
    handleCancelLabelsDialog () {
      this.editInfoDialog = false
    },
    pickImg (data) {
      this.updateForm[this.pickerImgType] = data.url
      // this.updateForm.current_url = data.url;
      this.imgDialog = false
    },
    handleImgPicker (pickerImgType) {
      this.pickerImgType = pickerImgType
      this.imgDialog = true
      this.isGetImage = true
    },
    closeImgDialog () {
      this.imgDialog = false
      this.isGetImage = false
    },
    handleSelectionChange (val) {
      console.log(val)
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getSucai(this.params)
    }
  },
  mounted () {
    this.getSucai(this.params)
    let param = {
      page: 1,
      pageSize: 100
    }
  },
  watch: {
    // 分页全选-监听数据变化
    sucaiData: {
      handler (value) {
        if (this.allCheck) {
          this.sucaiData.forEach(row => {
            if (row) {
              this.$refs.multipleTable.toggleRowSelection(row, true)
            }
          })
        }
      },
      deep: true
    }
  }
}
</script>
<style>
.frm-tips {
  color: #e76c34;
}
</style>



// WEBPACK FOOTER //
// sucai_list.vue?637e268d